<template>
    <div class="card" style="padding: 1em 1em 1em 1em;">
        <div class="p-grid">
            <div class="ttitle">{{$store.state.title[i18n.locale()]}}</div>
            <div class="p-col-12">
				<DataTable :value="products" :paginator="true" stripedRows class="p-datatable-customers p-datatable-sm"
                        :rows="5" dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" :filters="filters"
						:rowsPerPageOptions="[5, 10, 20, 50]" scrollable scrollHeight="400px">
					<template #header>
						<div class="table-header">
							<div>{{$t('Records')}}: {{ products.length }}</div>
							<div>
								<Button icon="pi pi-refresh" class="p-button-rounded p-button-secondary p-mr-2 p-mb-2" v-tooltip.bottom="$t('Refresh')" @click="Start"/>
							</div>
						</div>
					</template>
					<Column field="id" :header="$t('Date')" headerStyle="width: 10%">
						<template #body="slotProps">
							{{slotProps.data['date_'+i18n.locale()]}}
						</template>
					</Column>
					<Column field="responsible" :header="$t('Responsible')"/>
					<Column :header="$t('Internal Evaluation')" headerStyle="width: 10%">
						<template #body="slotProps">
							<Tag :style="'background-color: #'+Scale(slotProps.data.internal)['color']" v-if="slotProps.data.stage>0">
								{{parseFloat(slotProps.data.internal).toFixed(0)}}
								{{Scale(slotProps.data.internal)[i18n.locale()]}}
							</Tag>
						</template>
					</Column>
					<Column :header="$t('External Evaluation')" headerStyle="width: 10%">
						<template #body="slotProps">
							<Tag :style="'background-color: #'+Scale(slotProps.data.external)['color']" v-if="slotProps.data.stage_ext>0">
								{{parseFloat(slotProps.data.internal).toFixed(0)}}
								{{Scale(slotProps.data.external)[i18n.locale()]}}
							</Tag>
						</template>
					</Column>
					<Column :header="$t('Progress')" headerStyle="width: 10%">
						<template #body="slotProps">
                           <ProgressBar :value="(parseInt(slotProps.data.finish_action)*100/parseInt(slotProps.data.pend_action)).toFixed(1)"  v-if="slotProps.data.pend_action>0"/>
                           <ProgressBar value="0"  v-else/>                            
						</template>
					</Column>
					<Column :header="$t('Items')" headerStyle="width: 10%">
						<template #body="slotProps">
							{{slotProps.data.pend_action}}
						</template>
					</Column>
					<Column :header="$t('Actions')" headerStyle="width: 10%">
						<template #body="slotProps">
							<Button icon="pi pi-eye" class="p-button-rounded  p-button-secondary p-mr-2" @click="Result(slotProps.data)" v-tooltip.bottom="$t('Result')" />
							<Button icon="pi pi-pencil" class="p-button-rounded  p-button-secondary p-mr-2" @click="Edit(slotProps.data)" v-if="edit" v-tooltip.bottom="$t('Edit')" :disabled="slotProps.data.pend_action==0"/>
						</template>
					</Column>
				</DataTable>
			</div>
		</div>
	</div>
	<Dialog v-model:visible="ResultDialog"   :header="$t('Result')" :modal="true" :maximizable="true">
        <Results :result="results" :scl="scale" :intern="true"/>
		<template #footer>
			<Button :label="$t('Close')" icon="pi pi-times" class="p-button-secondary" @click="ResultDialog = false"/>
		</template>
    </Dialog>
	
	<Detail @save-close="Start" v-if="$store.state.planning.display" :title="$store.state.title[i18n.locale()]"/>
</template>

<script>
	import API from "../service/API";
	var Consult = new API('Evaluation','AnalyPlanning');
	import { useI18nPlugin } from '@unify/vuex-i18n';
    import { defineAsyncComponent } from "@vue/runtime-core";

	export default {
        components: {
			Detail: defineAsyncComponent(() => import('../components/Eval_Detail.vue')),
			Results: defineAsyncComponent(() => import('../components/Results.vue')),
        },
		data() {
			return {
				i18n: null,
				newid: false,
				search: null,
				options: null,
				option: null,
				insert: false,
				edit: false,
				del: false,
				products: [],
				productDialog: false,
				ResultDialog: false,
				ExtDialog: false,
				deleteProductDialog: false,
				deleteProductsDialog: false,
				product: {},
				selectedCustomers: null,
				filters: {},
				size: '30vw',
				scale: [],
				results: null,
			}
		},
		productService: null,
		created() {
            this.i18n = useI18nPlugin();
			this.$store.commit('Validate',this.$route);
			if (this.$store.state.mobile){this.size = '90vw';}
			this.Start();
		},
		mounted() {
			
		},
		methods: {
			Start() {
				this.product = [];
				Consult.Ini().then(response => {
					//this.$store.state.error = response;
					this.insert = response.insert;
					this.edit = response.edit;
					this.del = response.delete;
					this.scale = response.result.scale;
					this.products = response.result.evaluation;
				}); 
			},
			Result(product) {
				this.results = null;
				this.$store.state.evaluation.data = {...product};
                Consult.Process('Result',{
					inf: 	product.id
				}).then(response => {
					//this.$store.state.error =  response;
					if (response.result) {
                        this.results = response.result;
						this.ResultDialog = true;
					} 				
				});	
			},
			Edit(product) {
				this.$store.state.planning.data = {...product};
                Consult.Process('Analy_Plan',{
					inf: 	product
				}).then(response => {
					//this.$store.state.error =  response;
					if (response.result) {
                        this.$store.state.planning.detail = response.result.answers;
						this.$store.state.planning.clasification = response.result.clasification;
						this.$store.state.planning.scale = response.result.scale;
						this.$store.state.planning.status = response.result.status;
						this.$store.state.planning.impact = response.result.impact;
						this.$store.state.planning.urengence = response.result.urengence;
						this.$store.state.planning.display = true;
					} 			
				});	
			},
			Scale(valor){
				return this.scale.filter(val => parseFloat(val.min)<= parseFloat(valor) && parseFloat(val.max)>= parseFloat(valor))[0];
			}
		}
	}
</script>

<style scoped lang="scss">
.ttitle{
    font-family: 'Rajdhani', sans-serif;
    font-size: calc(0.7rem + 1vw);
    font-weight: 600;
    color: #2b3b80;
    padding: 1em 0em 1em 0.5em;
}
.text-title{
    font-family: 'Rajdhani', sans-serif;
    font-size: calc(0.7rem + 1vw);
    font-weight: 600;
    color: #2b3b80;
}

.p-datatable .p-column-filter {
	display: none;
}

.table-header {
	display: flex;
	justify-content: space-between;
}

::v-deep(.p-datatable.p-datatable-customers) {
	.p-datatable-header {
		padding: 1rem;
		text-align: left;
		font-size: 1.5rem;
	}

	.p-paginator {
		padding: 1rem;
	}

	.p-datatable-thead > tr > th {
		text-align: left;
	}

	.p-datatable-tbody > tr > td {
		cursor: auto;
	}

	.p-dropdown-label:not(.p-placeholder) {
		text-transform: uppercase;
	}
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
	display: none;
}

.customer-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.status-qualified {
		background: #C8E6C9;
		color: #256029;
	}

	&.status-unqualified {
		background: #FFCDD2;
		color: #C63737;
	}

	&.status-negotiation {
		background: #FEEDAF;
		color: #8A5340;
	}

	&.status-new {
		background: #B3E5FC;
		color: #23547B;
	}

	&.status-renewal {
		background: #ECCFFF;
		color: #694382;
	}

	&.status-proposal {
		background: #FFD8B2;
		color: #805B36;
	}
}



@media (max-width: 640px) {

}

.product-image {
	width: 100px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
}

.orders-subtable {
	padding: 1rem;
}

.product-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.status-instock {
		background: #C8E6C9;
		color: #256029;
	}

	&.status-outofstock {
		background: #FFCDD2;
		color: #C63737;
	}

	&.status-lowstock {
		background: #FEEDAF;
		color: #8A5340;
	}
}

.order-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.order-delivered {
		background: #C8E6C9;
		color: #256029;
	}

	&.order-cancelled {
		background: #FFCDD2;
		color: #C63737;
	}

	&.order-pending {
		background: #FEEDAF;
		color: #8A5340;
	}

	&.order-returned {
		background: #ECCFFF;
		color: #694382;
	}
}

@media screen and (max-width: 960px) {
	::v-deep(.p-datatable) {
		&.p-datatable-customers {
			.p-datatable-thead > tr > th,
			.p-datatable-tfoot > tr > td {
				display: none !important;
			}

			.p-datatable-tbody > tr {
				> td {
					text-align: left;
					display: block;
					border: 0 none !important;
					width: 100% !important;
					float: left;
					clear: left;
					border: 0 none;

					.p-column-title {
						padding: .4rem;
						min-width: 30%;
						display: inline-block;
						margin: -.4rem 1rem -.4rem -.4rem;
						font-weight: bold;
					}


				}
			}
		}
	}
}
</style>